import React from 'react';
const inputMin = ({type,name,label,value,error,onChange,placeholder,min,max,step,width})=>{
    return(
        <div className="form-group row" style={{borderBottom:"none"}}>
        <label style={{ display:"flex" , alignItems:"center" , fontWeight:"bold" , color:"gray"}}  className="col-lg-4"  htmlFor={name}>{label}</label>
        <div className="col-lg-8">
        <div className="row row-space-10">
            <input
             type={type}
              className="form-control m-b-5"

              //placeholder="Enter email"
              name={name} 
              id={name}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              min={min}
              max={max}
              step={step}
              style={{ width: width , marginLeft: "10px"} } 
            />
             </div>
         {error && <div className="alert alert-danger">{error}</div>}
        </div>
    </div>





        );
};
export default inputMin;